import { render } from "./CustomCheckboxTagsFilter.vue?vue&type=template&id=f58d16ec"
import script from "./CustomCheckboxTagsFilter.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxTagsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__